import { Pagination as MatchboxPagination } from '@sparkpost/matchbox';

/**
 * Matchbox Pagination component.
 * @see https://design.sparkpost.com/components/pagination/
 */
const Pagination = MatchboxPagination;

export default Pagination;
